import { render, staticRenderFns } from "./corporateProfiles.vue?vue&type=template&id=c1aa2e4c&"
import script from "./corporateProfiles.vue?vue&type=script&lang=js&"
export * from "./corporateProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports